import React, { useRef } from 'react';
import { styled } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { ListItem, List, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';

const Accordion = styled((props: any) => (
  <MuiAccordion {...props} />
))(() => ({
  'boxShadow': 'none',
  'marginBottom': '12px',
  'borderRadius': '8px',
  'background': '#2E3036',
  'color': '#EFF1F6',
  'fontFamily': 'Inter',
  'fontSize': '16px',
  'fontStyle': 'normal',
  'fontWeight': 600,
  'lineHeight': '22px',
  '&:hover': {
    background: '#25262B'
  }
}));

const AccordionSummary = styled((props:any) => (
  <MuiAccordionSummary
    {...props}
  />
))(() => ({
  'backgroundColor': 'rgba(0, 0, 0, .03)',
  'marginBottom': -1,
  'minHeight': 56,
  '&$expanded': {
    minHeight: 56,
  },
  '& .MuiAccordionSummary-expandIcon': {
    color: '#F5FAFF'
  },
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    '&$expanded': {
      margin: '12px 0',
    },
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(() => ({
  padding: '10px',
  color: '#BDBEC1',
  fontFamily: 'Inter',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '21px',
}));

const FAQ: React.FC = () => {
  const [ expanded, setExpanded ] = React.useState<string | false>(false);

  const tawkMessengerRef = useRef<any>();

  const onLoad = () => {
    if (tawkMessengerRef.current) {
      tawkMessengerRef.current.minimize();
    }
  };

  const handleTawkToggle = () => {
    if (tawkMessengerRef.current) {
      tawkMessengerRef.current.toggle();
    }
  };

  const handleChange = (panel: string) => (event: React.ChangeEvent<any>, newExpanded: boolean) => {
    setExpanded(newExpanded ? panel : false);
  };

  const plusIcon = <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
    <path d='M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
  </svg>;

  const minusIcon = <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
    <path d='M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
  </svg>;

  return (
    <section className='home-content-body Home-HeaderDown' style={{ minHeight: 0 }} >
      <Grid container>
        <Grid item xs={12}>
          <div className='module-header'>
            <div className='module-header-breadcrumbs'>
              <Link to='/'>
                <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none' cursor={'pointer'}>
                  <path d='M7.5 17.5V11.3333C7.5 10.8666 7.5 10.6333 7.59083 10.455C7.67072 10.2982 7.79821 10.1707 7.95501 10.0908C8.13327 9.99999 8.36662 9.99999 8.83333 9.99999H11.1667C11.6334 9.99999 11.8667 9.99999 12.045 10.0908C12.2018 10.1707 12.3293 10.2982 12.4092 10.455C12.5 10.6333 12.5 10.8666 12.5 11.3333V17.5M9.18141 2.30333L3.52949 6.69927C3.15168 6.99312 2.96278 7.14005 2.82669 7.32405C2.70614 7.48704 2.61633 7.67065 2.56169 7.86588C2.5 8.08627 2.5 8.32558 2.5 8.80421V14.8333C2.5 15.7667 2.5 16.2335 2.68166 16.59C2.84144 16.9036 3.09641 17.1585 3.41002 17.3183C3.76654 17.5 4.23325 17.5 5.16667 17.5H14.8333C15.7668 17.5 16.2335 17.5 16.59 17.3183C16.9036 17.1585 17.1586 16.9036 17.3183 16.59C17.5 16.2335 17.5 15.7667 17.5 14.8333V8.80421C17.5 8.32558 17.5 8.08627 17.4383 7.86588C17.3837 7.67065 17.2939 7.48704 17.1733 7.32405C17.0372 7.14005 16.8483 6.99312 16.4705 6.69927L10.8186 2.30333C10.5258 2.07562 10.3794 1.96177 10.2178 1.918C10.0752 1.87938 9.92484 1.87938 9.78221 1.918C9.62057 1.96177 9.47418 2.07562 9.18141 2.30333Z' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              </Link>
              <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                <path d='M6 12L10 8L6 4' stroke='#D0D5DD' strokeWidth='1.33333' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
              <div className='bc-title'>
                Help Center
              </div>
            </div>
            <div className='homepage-header-title-cont'>
              <h1>Help Center</h1>
              <div className='module-header-btns'>
                <button className='chat-spt-btn' onClick={handleTawkToggle}>
                  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                    <g clipPath='url(#clip0_10048_917)'>
                      <path d='M5.07864 9.35733C5.02685 9.02353 4.99997 8.68155 4.99997 8.33334C4.99997 4.65144 8.00438 1.66667 11.7105 1.66667C15.4166 1.66667 18.421 4.65144 18.421 8.33334C18.421 9.16507 18.2677 9.96122 17.9876 10.6954C17.9295 10.8479 17.9004 10.9242 17.8872 10.9837C17.8741 11.0427 17.869 11.0842 17.8676 11.1445C17.8662 11.2055 17.8744 11.2727 17.891 11.4069L18.2265 14.1321C18.2628 14.4271 18.2809 14.5746 18.2319 14.6819C18.1889 14.7758 18.1125 14.8504 18.0176 14.8913C17.9092 14.9378 17.7622 14.9163 17.4681 14.8732L14.8137 14.4841C14.6751 14.4638 14.6058 14.4536 14.5427 14.454C14.4803 14.4543 14.4371 14.4589 14.376 14.4718C14.3142 14.4848 14.2353 14.5143 14.0775 14.5734C13.3414 14.8492 12.5437 15 11.7105 15C11.362 15 11.0197 14.9736 10.6856 14.9227M6.35965 18.3333C8.8304 18.3333 10.8333 16.2813 10.8333 13.75C10.8333 11.2187 8.8304 9.16667 6.35965 9.16667C3.88891 9.16667 1.88597 11.2187 1.88597 13.75C1.88597 14.2588 1.9669 14.7483 2.1163 15.2056C2.17945 15.3989 2.21102 15.4956 2.22139 15.5616C2.2322 15.6306 2.2341 15.6693 2.23007 15.7389C2.22621 15.8057 2.20952 15.8811 2.17613 16.0319L1.66667 18.3333L4.16234 17.9925C4.29856 17.9739 4.36667 17.9646 4.42615 17.965C4.48877 17.9654 4.52201 17.9688 4.58343 17.9811C4.64176 17.9927 4.72847 18.0233 4.9019 18.0845C5.35883 18.2458 5.84926 18.3333 6.35965 18.3333Z' stroke='#BDBEC1' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                    </g>
                    <defs>
                      <clipPath id='clip0_10048_917'>
                        <rect width='20' height='20' fill='white'/>
                      </clipPath>
                    </defs>
                  </svg>
                 Chat Support
                </button>
                <a href='mailto:support@bitedata.io'>
                  <button className='contact-btn'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                      <path d='M17.9166 15L12.3809 9.99999M7.61904 9.99999L2.08335 15M1.66666 5.83333L8.47076 10.5962C9.02173 10.9819 9.29722 11.1747 9.59688 11.2494C9.86157 11.3154 10.1384 11.3154 10.4031 11.2494C10.7028 11.1747 10.9782 10.9819 11.5292 10.5962L18.3333 5.83333M5.66666 16.6667H14.3333C15.7335 16.6667 16.4335 16.6667 16.9683 16.3942C17.4387 16.1545 17.8212 15.772 18.0608 15.3016C18.3333 14.7669 18.3333 14.0668 18.3333 12.6667V7.33333C18.3333 5.9332 18.3333 5.23313 18.0608 4.69835C17.8212 4.22795 17.4387 3.8455 16.9683 3.60581C16.4335 3.33333 15.7335 3.33333 14.3333 3.33333H5.66666C4.26653 3.33333 3.56646 3.33333 3.03168 3.60581C2.56128 3.8455 2.17882 4.22795 1.93914 4.69835C1.66666 5.23313 1.66666 5.9332 1.66666 7.33333V12.6667C1.66666 14.0668 1.66666 14.7669 1.93914 15.3016C2.17882 15.772 2.56128 16.1545 3.03168 16.3942C3.56646 16.6667 4.26653 16.6667 5.66666 16.6667Z' stroke='#EFF1F6' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                    </svg>
                  Contact Us
                  </button>
                </a>

              </div>
            </div>
          </div>
        </Grid>
        <div className='HomeDashboard-container'>
          <div className='support-link-grp'>
            <div className='support-module'>
              <Link to='/resources' className='hover-box'>
                <div className='module-icon'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                    <path d='M5 10V16.0111C5 16.3701 5 16.5496 5.05465 16.708C5.10299 16.8482 5.18187 16.9758 5.28558 17.0817C5.40287 17.2014 5.5634 17.2817 5.88446 17.4422L11.2845 20.1422C11.5468 20.2734 11.678 20.339 11.8156 20.3648C11.9375 20.3877 12.0625 20.3877 12.1844 20.3648C12.322 20.339 12.4532 20.2734 12.7155 20.1422L18.1155 17.4422C18.4366 17.2817 18.5971 17.2014 18.7144 17.0817C18.8181 16.9758 18.897 16.8482 18.9453 16.708C19 16.5496 19 16.3701 19 16.0111V10M2 8.5L11.6422 3.67889C11.7734 3.6133 11.839 3.5805 11.9078 3.5676C11.9687 3.55616 12.0313 3.55616 12.0922 3.5676C12.161 3.5805 12.2266 3.6133 12.3578 3.67889L22 8.5L12.3578 13.3211C12.2266 13.3867 12.161 13.4195 12.0922 13.4324C12.0313 13.4438 11.9687 13.4438 11.9078 13.4324C11.839 13.4195 11.7734 13.3867 11.6422 13.3211L2 8.5Z' stroke='#E5F2FD' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                  </svg>
                </div>
                <div className='support-info'>
                  <div className='module-title'>
                    <h2>Training</h2>
                  </div>
                  <div className='module-desc'>
                    <Typography
                      variant='subtitle2'
                    >
                  Get formal education and training for you or your team with BITE U.
                    </Typography>
                  </div>
                </div>
              </Link>
            </div>


            <div className='support-module'>
              <a href='mailto:support@bitedata.io' className='hover-box'>
                <div className='module-icon'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                    <path d='M5 10V16.0111C5 16.3701 5 16.5496 5.05465 16.708C5.10299 16.8482 5.18187 16.9758 5.28558 17.0817C5.40287 17.2014 5.5634 17.2817 5.88446 17.4422L11.2845 20.1422C11.5468 20.2734 11.678 20.339 11.8156 20.3648C11.9375 20.3877 12.0625 20.3877 12.1844 20.3648C12.322 20.339 12.4532 20.2734 12.7155 20.1422L18.1155 17.4422C18.4366 17.2817 18.5971 17.2014 18.7144 17.0817C18.8181 16.9758 18.897 16.8482 18.9453 16.708C19 16.5496 19 16.3701 19 16.0111V10M2 8.5L11.6422 3.67889C11.7734 3.6133 11.839 3.5805 11.9078 3.5676C11.9687 3.55616 12.0313 3.55616 12.0922 3.5676C12.161 3.5805 12.2266 3.6133 12.3578 3.67889L22 8.5L12.3578 13.3211C12.2266 13.3867 12.161 13.4195 12.0922 13.4324C12.0313 13.4438 11.9687 13.4438 11.9078 13.4324C11.839 13.4195 11.7734 13.3867 11.6422 13.3211L2 8.5Z' stroke='#E5F2FD' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                  </svg>
                </div>
                <div className='support-info'>
                  <div className='module-title'>
                    <h2>Contact Us</h2>
                  </div>
                  <div className='module-desc'>
                    <Typography
                      variant='subtitle2'
                    >
                  Have a specific question? Reach out to us at support@bitedata.io.
                    </Typography>
                  </div>
                </div>
              </a>
            </div>

            <div className='support-module'>
              <a className='hover-box' onClick={handleTawkToggle}>
                <div className='module-icon'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                    <path d='M5 10V16.0111C5 16.3701 5 16.5496 5.05465 16.708C5.10299 16.8482 5.18187 16.9758 5.28558 17.0817C5.40287 17.2014 5.5634 17.2817 5.88446 17.4422L11.2845 20.1422C11.5468 20.2734 11.678 20.339 11.8156 20.3648C11.9375 20.3877 12.0625 20.3877 12.1844 20.3648C12.322 20.339 12.4532 20.2734 12.7155 20.1422L18.1155 17.4422C18.4366 17.2817 18.5971 17.2014 18.7144 17.0817C18.8181 16.9758 18.897 16.8482 18.9453 16.708C19 16.5496 19 16.3701 19 16.0111V10M2 8.5L11.6422 3.67889C11.7734 3.6133 11.839 3.5805 11.9078 3.5676C11.9687 3.55616 12.0313 3.55616 12.0922 3.5676C12.161 3.5805 12.2266 3.6133 12.3578 3.67889L22 8.5L12.3578 13.3211C12.2266 13.3867 12.161 13.4195 12.0922 13.4324C12.0313 13.4438 11.9687 13.4438 11.9078 13.4324C11.839 13.4195 11.7734 13.3867 11.6422 13.3211L2 8.5Z' stroke='#E5F2FD' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                  </svg>
                </div>
                <div className='support-info'>
                  <div className='module-title'>
                    <h2>Chat Support</h2>
                  </div>
                  <div className='module-desc'>
                    <Typography
                      variant='subtitle2'
                    >
                  Have an urgent question? Click on the chat bubble to get started.
                    </Typography>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div className='homepage-header-title-cont'>
            <h1>FAQs</h1>
          </div>
          <div className='faq-container'>
            <Accordion square expanded={expanded === 'panel1'} onChange={handleChange('panel1')} style={{ background: 'transparent', width: '80%' }}>
              <AccordionSummary aria-controls='panel1d-content' id='panel1d-header' expandIcon={expanded === 'panel1' ? minusIcon : plusIcon} >
                <Typography>What is BITE?</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
            The Business Intelligence for Trade Enforcement (BITE) platform is a cost-effective and
            easy-to-use platform that allows companies and organizations to monitor, identify and mitigate
            risk in their supply chain, and remain on the right side of trade compliance.
                  <br></br>
                  <br></br>
            The platform includes two core modules:
                  <br></br>
                  <List>
                    <ListItem>
                    A Web application that helps compliance and enforcement officers access the latest
                    watchlists, sanctions lists, commodity regimes, cyber vulnerabilities, and more to help
                    identify risk in real-time.
                    </ListItem>
                    <ListItem>
                  Artificial Intelligence (AI) platform that includes millions of worldwide trade records.
                  BITE engineers and subject matter experts use the data to investigate specific areas for
                  customers and create customized reports, and identify entities that are partaking in risky
                  trade practices. These entities are added to the High Risk Entities List and available via the Web app.
                    </ListItem>
                  </List>
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion square expanded={expanded === 'panel2'} onChange={handleChange('panel2')} style={{ background: 'transparent', width: '80%' }}>
              <AccordionSummary aria-controls='panel2d-content' id='panel2d-header' expandIcon={expanded === 'panel2' ? minusIcon : plusIcon}>
                <Typography>Who uses BITE?</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
            BITE is used by private and government personnel across multiple compliance and enforcement domains.
            Check out our cases here for info on the different types of activities and groups we support.
                  <br></br>
                  <br></br>
            The tool is used by multiple agencies in the US and EU.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion square expanded={expanded === 'panel3'} onChange={handleChange('panel3')} style={{ background: 'transparent', width: '80%' }}>
              <AccordionSummary aria-controls='panel3d-content' id='panel3d-header' expandIcon={expanded === 'panel3' ? minusIcon : plusIcon}>
                <Typography>Where can I learn more about BITE?</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
              Take a look at this overview video of the platform&nbsp;
                  <a href='https://www.youtube.com/watch?v=qGYDF7mlh-Y' target='_blank' rel='noreferrer'>here</a>
                  <br></br>
                  <br></br>
              You can also take a look at the Products page as well as our Blog page to learn more about what we do.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion square expanded={expanded === 'panel4'} onChange={handleChange('panel4')} style={{ background: 'transparent', width: '80%' }}>
              <AccordionSummary aria-controls='panel3d-content' id='panel3d-header' expandIcon={expanded === 'panel4' ? minusIcon : plusIcon}>
                <Typography>How much does BITE Cost?</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
            BITE is priced very competitively, and all our pricing is transparent, listed&nbsp;
                  <a href='https://www.bitedata.io/pricing' target='_blank' rel='noreferrer'>here</a>
                  <br></br>
                  <br></br>
            Contact us for more information regarding bundling and discounts -&nbsp;
                  <a href='mailto:info@bitedata.io'>info@bitedata.io</a>
            .
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion square expanded={expanded === 'panel5'} onChange={handleChange('panel5')} style={{ background: 'transparent', width: '80%' }}>
              <AccordionSummary aria-controls='panel3d-content' id='panel3d-header' expandIcon={expanded === 'panel5' ? minusIcon : plusIcon}>
                <Typography>Can I access BITE via API?</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
            Yes - all data in our web app is available via Application Programming Interface (API).
            Please check out our Developer Docs <Link to='/developer-docs'>here</Link>.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion square expanded={expanded === 'panel6'} onChange={handleChange('panel6')} style={{ background: 'transparent', width: '80%' }}>
              <AccordionSummary aria-controls='panel3d-content' id='panel3d-header' expandIcon={expanded === 'panel6' ? minusIcon : plusIcon}>
                <Typography>Where can I get more information about BITE?</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
            Have more questions - contact us to set up a call&nbsp;
                  <a href='https://www.bitedata.io/contact' target='_blank' rel='noreferrer'>here</a>.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </Grid>
      <TawkMessengerReact
        propertyId='663c243d07f59932ab3d73e6'
        widgetId='1htder4kb'
        onLoad={onLoad}
        ref={tawkMessengerRef}
      />
    </section>
  );
};

export default FAQ;
